import "./createBlog.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import blogApi from "../../apis/blogApi";
import { Alert, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { Label } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom"; // ✅ v6
import DefaultLayout from "../layout/DefaultLayout";
import S3 from "react-aws-s3";
import JoditEditor from "jodit-react";

const joditConfig = {
  readonly: false,
  placeholder: "Start typing...",
};

const CreateBlog = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [authorName, setAuthorName] = useState("");
  const [authorLink, setAuthorLink] = useState("");
  const [editorLink, setEditorLink] = useState("");
  const [editedBy, setEditedBy] = useState("");
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const editor = useRef(null);

  const navigate = useNavigate(); // ✅ replaced useHistory
  const { user } = useSelector((state) => state.user);
  const authorId = user?._id;

  const config = {
    bucketName: process.env.REACT_APP_S3_BUCKET_NAME,
    region: process.env.REACT_APP_S3_REGION,
    accessKeyId: process.env.REACT_APP_AWS_AKID,
    secretAccessKey: process.env.REACT_APP_AWS_SAK,
  };

  const createBlog = async () => {
    if (!title || !file || !content || !authorName) {
      setError("Please fill out all required fields!");
      return;
    }
    setError("");
    setSaving(true);

    try {
      const ReactS3Client = new S3(config);
      const upload = await ReactS3Client.uploadFile(
        file,
        Date.now() + file.name
      );

      const newBlog = {
        title,
        content,
        authorName,
        authorLink,
        editorLink,
        authorId,
        image: upload.location,
        editedBy,
      };

      const res = await blogApi.createABlog(newBlog);
      if (res._id) {
        toast.success("Blog posted successfully!");
        navigate("/blog"); // ✅ replaced history.push
      } else {
        setError("Blog post failed!");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while posting the blog.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <DefaultLayout>
      <div className="blog-editor">
        <header className="blog-header mt-2">
          <button
            onClick={() => navigate("/blog")} // ✅ replaced history.push
            className="blog-button"
          >
            &lt; Back
          </button>
          Create Blog
        </header>

        {error && (
          <Alert variant="danger" className="mt-4">
            {error}
          </Alert>
        )}

        <div className="p-3">
          <Form className="blog-form">
            <Form.Group className="mb-3">
              <Label className="mb-2">Title *</Label>
              <Form.Control
                type="text"
                placeholder="Enter a title ..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Label className="mb-2">Image</Label>
              <Form.Control
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Row>
                <Col md={6}>
                  <Label className="mb-2">Author</Label>
                  <Form.Control
                    type="text"
                    placeholder="Author Name"
                    value={authorName}
                    onChange={(e) => setAuthorName(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Label className="mb-2">Social Link</Label>
                  <Form.Control
                    type="text"
                    placeholder="LinkedIn"
                    value={authorLink}
                    onChange={(e) => setAuthorLink(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Row>
                <Col md={6}>
                  <Label className="mb-2">Editor</Label>
                  <Form.Control
                    type="text"
                    placeholder="Edited By"
                    value={editedBy}
                    onChange={(e) => setEditedBy(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Label className="mb-2">Social Link</Label>
                  <Form.Control
                    type="text"
                    placeholder="LinkedIn"
                    value={editorLink}
                    onChange={(e) => setEditorLink(e.target.value)}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Label className="mb-2">Content</Label>
              <JoditEditor
                ref={editor}
                value={content}
                config={joditConfig}
                onChange={(newContent) => setContent(newContent)}
              />
            </Form.Group>

            <Form.Group className="button-loader">
              <Button className="btn btn-warning" onClick={createBlog}>
                Post <i className="fas fa-save ms-2"></i>
              </Button>
              {saving && <Spinner animation="border" />}
            </Form.Group>
          </Form>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default CreateBlog;
